/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { REPORTS_DASHBOARD, SCHEDULE_LIST, SCHEDULE_META } from '@modules/app/Api';
import { ITableInitialise } from '@modules/table/types';

import type { IConstructorReport, IConstructorTemplate, TReportId } from '../types';

export const setRowId = <T extends { id: number }>(row: T[]): string => {
    return row.reduce((id, report) => {
        return (id += `_${report.id}`);
    }, '');
};

export const sliceItemsToRows = <T extends { id: number }>(
    items: T[],
    rowSize: number,
): Array<{ rowId: string, row: T[] }> => {
    const itemsRows = [] as unknown as Array<{ rowId: string, row: T[] }>;

    for (let i = 0; i < items.length; i += rowSize) {
        const row = items.slice(i, i + rowSize);
        const rowId = setRowId(row);
        itemsRows.push({ rowId, row });
    }

    return itemsRows;
};

export const isReport = (item: IConstructorReport | IConstructorTemplate): item is IConstructorReport =>
    Object.prototype.hasOwnProperty.call(item, 'title');

export const isTemplate = (item: IConstructorReport | IConstructorTemplate): item is IConstructorTemplate =>
    Object.prototype.hasOwnProperty.call(item, 'createDate');

export const setTableScheduleConfig = (reportId: TReportId, isTemplate: boolean): ITableInitialise => ({
    meta: {
        url: `${REPORTS_DASHBOARD}/${reportId}/${SCHEDULE_META}`,
    },
    list: {
        url: `${REPORTS_DASHBOARD}/${reportId}/${SCHEDULE_LIST}`,
        isTemplate,
    },
});
